export default theme => ({
  inputWrapper: {
    display: "flex",
    alignItems: "flex-end",
    height: "100%",
    "& > *": {
      width: "100%",
    },
    "& .MuiFormControl-root": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
    },
    "& .MuiFormControl-marginNormal": {
      marginTop: "0 !important",
      marginBottom: "0 !important",
    },
    "& .MuiFormHelperText-root": {
      marginTop: "0 !important",
      height: "0 !important",
      minHeight: "0 !important",
    },
    "& #searchAutocomplete": {
      marginBottom: "0 !important",
    },
    "& [class*='control']": {
      marginBottom: "0 !important",
    },
    "& [class*='container']": {
      minHeight: "0 !important",
    },
  },
  clearButton: {
    marginTop: theme.spacing(2),
  },
});
